/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUserRequestsUploadDocumentMutationRequest,
  PostUserRequestsUploadDocumentMutationResponse,
  PostUserRequestsUploadDocument400,
} from '../entities/PostUserRequestsUploadDocument'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUserRequestsUploadDocument } from '../api/postUserRequestsUploadDocument'
import { useMutation } from '@tanstack/react-query'

export const postUserRequestsUploadDocumentMutationKey = () => [{ url: '/user-requests/upload-document' }] as const

export type PostUserRequestsUploadDocumentMutationKey = ReturnType<typeof postUserRequestsUploadDocumentMutationKey>

/**
 * @description Загрузка документа
 * @summary Загрузка документа
 * {@link /user-requests/upload-document}
 */
export function usePostUserRequestsUploadDocument<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostUserRequestsUploadDocumentMutationResponse,
      ResponseErrorConfig<PostUserRequestsUploadDocument400>,
      { data: PostUserRequestsUploadDocumentMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostUserRequestsUploadDocumentMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUserRequestsUploadDocumentMutationKey()

  return useMutation<
    PostUserRequestsUploadDocumentMutationResponse,
    ResponseErrorConfig<PostUserRequestsUploadDocument400>,
    { data: PostUserRequestsUploadDocumentMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postUserRequestsUploadDocument(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}